import React from 'react';
import T from 'prop-types';
import styled from 'styled-components';
import { Button, DropdownMenu } from '@acast/decibel';
import { EllipsisHRegularGlyph } from '@acast/decibel-glyphs';
import fileUpload from '../../../../services/file-upload';
import MimeTypes from '../../../../shared/helpers/mime-types';

const FileInput = styled.input`
  display: none;
`;

const AudioUpload = ({ disabled, hasAudio, episodeId, showId, onChange }) => {
  const inputEl = React.useRef(null);
  const [loading, setLoading] = React.useState(false);
  const [file, setFile] = React.useState();

  const handleOpenFileSelect = () => {
    inputEl.current.click();
  };

  const handleFileSelect = e => {
    const selectedFile = e.target.files[0];

    if (selectedFile && MimeTypes.Audio.includes(selectedFile.type)) {
      setFile(selectedFile);
    }
  };

  const handleRemove = React.useCallback(() => onChange(null), [onChange]);

  React.useEffect(() => {
    let isCancelled = false;

    const cancellable = () => {
      isCancelled = true;
    };

    if (!file) {
      return cancellable;
    }

    setLoading(true);

    fileUpload.begin({ path: `${showId}/${episodeId}`, id: episodeId }, name, file).then(url => {
      if (isCancelled) {
        return;
      }

      setLoading(false);
      onChange(url);
    });

    return cancellable;
  }, [episodeId, file, onChange, showId]);

  return (
    <div>
      <FileInput type="file" accept={MimeTypes.Audio} onChange={handleFileSelect} ref={inputEl} />
      {hasAudio ? (
        <DropdownMenu toggle={<Button glyph={EllipsisHRegularGlyph} title="More" />}>
          <DropdownMenu.Menu>
            <DropdownMenu.Item onClick={handleOpenFileSelect}>Replace</DropdownMenu.Item>
            <DropdownMenu.Item onClick={handleRemove}>Remove</DropdownMenu.Item>
          </DropdownMenu.Menu>
        </DropdownMenu>
      ) : (
        <Button
          variant="secondary"
          disabled={disabled}
          onClick={handleOpenFileSelect}
          busy={loading}
        >
          Upload
        </Button>
      )}
    </div>
  );
};

AudioUpload.propTypes = {
  disabled: T.bool,
  episodeId: T.string.isRequired,
  hasAudio: T.bool.isRequired,
  onChange: T.func.isRequired,
  showId: T.string.isRequired,
};

AudioUpload.defaultProps = {
  disabled: false,
};

export default AudioUpload;
